/* Mykonos, 5 nov 2026: kleine aanvulling op de Upsell-app (app zelf blijft ongemoeid).
   1. Bedragen in de upsell-lade/-blok volgen de notatie van de rest van de winkel: EUR als "€49,99"
      (de app formatteert met Shopify.locale: "€49.99" op .eu en "€ 49,99" op .nl/.de).
   2. Geurnoten ("Blackcurrant · Lemon") worden op .nl/.de vertaald met het notenwoordenboek
      (assets/myk-upsell-notes.json, afgeleid van snippets/myk-note-dict.liquid). Onbekende noot = blijft Engels.
   Terugdraaien: het <script> met myk-upsell-locale.js uit layout/theme.liquid halen. */
(function () {
  var lang = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var me = document.currentScript, notesUrl = me && me.getAttribute('data-notes');
  var dict = null, loading = false, timer = 0;
  function price(el) {
    var t = el.textContent, m = t.match(/^\s*€\s?(\d{1,3})[.,](\d\d)\s*$/) || t.match(/^\s*(\d{1,3})[.,](\d\d)[\s ]*€\s*$/);
    if (!m) return;
    var n = '€' + m[1] + ',' + m[2];
    if (t !== n) el.textContent = n;
  }
  function notes(el) {
    if (!dict) return;
    var t = el.textContent, parts = t.split(' · '), changed = false;
    for (var i = 0; i < parts.length; i++) {
      var tr = dict[parts[i].trim().toLowerCase()];
      if (tr && tr !== parts[i]) { parts[i] = tr; changed = true; }
    }
    if (changed) el.textContent = parts.join(' · ');
  }
  function scan() {
    timer = 0;
    var p = document.querySelectorAll('.fg-upsell-item-price'), n = document.querySelectorAll('.fg-upsell-item-notes');
    for (var i = 0; i < p.length; i++) price(p[i]);
    if (!n.length || (lang !== 'nl' && lang !== 'de')) return;
    if (!dict && !loading && notesUrl) {
      loading = true;
      fetch(notesUrl).then(function (r) { return r.json(); }).then(function (j) { dict = j[lang] || {}; schedule(); }).catch(function () {});
      return;
    }
    for (var k = 0; k < n.length; k++) notes(n[k]);
  }
  function schedule() { if (!timer) timer = setTimeout(scan, 120); }
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
